import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Drag = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M5 3H7V5H5V3Z" fill={color || 'currentColor'} />
      <path d="M5 7H7V9H5V7Z" fill={color || 'currentColor'} />
      <path d="M5 11H7V13H5V11Z" fill={color || 'currentColor'} />
      <path d="M9 3H11V5H9V3Z" fill={color || 'currentColor'} />
      <path d="M9 7H11V9H9V7Z" fill={color || 'currentColor'} />
      <path d="M9 11H11V13H9V11Z" fill={color || 'currentColor'} />
    </svg>
  ),
)
Drag.displayName = 'Drag'

export default Drag
